module.exports = __webpack_public_path__ + "public/img/logo-dash.1b15757e.png";